import { terminalStatusContainer } from '../../types/types';
import { ITerminalStatus } from '../../models/terminal.interface';
import { showToast } from '../toasts';
import GetDispenserHeartBeat from '../../routes/get-terminal-status';

/**
 * Displays terminal status on the main dashboard screen
 * 
 * @returns void
 */
const DispenserStatus = async () => {
  if(!terminalStatusContainer) return;
  const { body } = await GetDispenserHeartBeat();

  if (!body) {
    showToast('aafp_toast-alert', 'Error getting terminal status');
    return;
  }

  displayInactiveTerminals(body.results);

  const visibleHeight = terminalStatusContainer.offsetHeight;
  const layoutHeight = terminalStatusContainer.scrollHeight;
  const shouldShowButton = 200 <= layoutHeight;
  if (shouldShowButton) {
    const expandButton = document.querySelector('#aafp_expand-terminals') as HTMLButtonElement;
    if (expandButton) {
      expandButton.style.display = 'block';

      expandButton.addEventListener('click', () => {
        if (terminalStatusContainer.style.maxHeight) {
          terminalStatusContainer.style.maxHeight = '';
          expandButton.innerHTML = `<span>EXPAND</span><i class="fas fa-plus"></i>`;
        } else {
          terminalStatusContainer.style.maxHeight = `${layoutHeight}px`;
          expandButton.innerHTML = `<span>COLLAPSE</span><i class="fas fa-minus"></i>`;
        }      
      });
    }
  }
};

/**
 * Displays the inactive terminals.  If there are no inactive terminals, it will display
 * a single widget that says all terminals are active.
 * 
 * @param {object} data the terminal data
 * 
 * @returns void
 */
const displayInactiveTerminals = (data: ITerminalStatus[]) => {
  //console.log(data)
  terminalStatusContainer.innerHTML = '';

  if (Object.keys(data).length === 0) {
    const terminalDiv = document.createElement('div');
    terminalDiv.classList.add('aafp_terminal-active', 'd-active');

    const terminalInnerDiv = document.createElement('div');
    terminalInnerDiv.classList.add('aafp_terminal-inner');
    terminalDiv.appendChild(terminalInnerDiv);

    const terminalWrapperDiv = document.createElement('div');
    terminalWrapperDiv.classList.add('aafp_terminal-wrapper');
    terminalInnerDiv.appendChild(terminalWrapperDiv);

    const terminalLink = document.createElement('a');
    terminalLink.href = '/terminals/';
    terminalLink.setAttribute('aria-label', 'All terminals active');
    terminalWrapperDiv.appendChild(terminalLink);

    const terminalWrapperInnerDiv = document.createElement('div');
    terminalWrapperInnerDiv.classList.add('aafp_terminal-wrapper-inner');
    terminalWrapperDiv.appendChild(terminalWrapperInnerDiv);

    const terminalNameSpan = document.createElement('span');
    terminalNameSpan.classList.add('aafp_terminal-name');
    terminalNameSpan.textContent = 'All Terminals';
    terminalWrapperInnerDiv.appendChild(terminalNameSpan);

    const terminalStatusSpan = document.createElement('span');
    terminalStatusSpan.classList.add('aafp_terminal-status');
    terminalStatusSpan.textContent = 'Active';
    terminalWrapperInnerDiv.appendChild(terminalStatusSpan);

    terminalStatusContainer.appendChild(terminalDiv);
    return;
  }

  for (let item in data) {
    const terminalDiv = document.createElement('div');
    terminalDiv.classList.add('aafp_terminal', 'd-inactive');

    const terminalInnerDiv = document.createElement('div');
    terminalInnerDiv.classList.add('aafp_terminal-inner');
    terminalDiv.appendChild(terminalInnerDiv);

    const terminalWrapperDiv = document.createElement('div');
    terminalWrapperDiv.classList.add('aafp_terminal-wrapper');
    terminalInnerDiv.appendChild(terminalWrapperDiv);

    const terminalLink = document.createElement('a');
    terminalLink.href = `/terminals/edit-terminal/?terminalAction=edit&terminalID=${data[item].terminalId}`;
    terminalLink.setAttribute('aria-label', data[item].terminalName);
    terminalWrapperDiv.appendChild(terminalLink);

    const terminalWrapperInnerDiv = document.createElement('div');
    terminalWrapperInnerDiv.classList.add('aafp_terminal-wrapper-inner');
    terminalWrapperDiv.appendChild(terminalWrapperInnerDiv);

    const terminalNameSpan = document.createElement('span');
    terminalNameSpan.classList.add('aafp_terminal-name');
    // if terminalName is empty, use terminalId only else use terminalName and terminalId
    terminalNameSpan.innerHTML = data[item].terminalName === '' ? `<p>${data[item].terminalId}</p>` : `<p>${data[item].terminalName}</p><p>${data[item].terminalId}</p>`;
    terminalWrapperInnerDiv.appendChild(terminalNameSpan);

    const terminalStatusSpan = document.createElement('span');
    terminalStatusSpan.classList.add('aafp_terminal-status');
    terminalStatusSpan.textContent = 'Non Responsive';
    terminalWrapperInnerDiv.appendChild(terminalStatusSpan);

    terminalStatusContainer.appendChild(terminalDiv);
  }
};

export default DispenserStatus;